'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  overflow: _propTypes2.default.string,
  overflowX: _propTypes2.default.string,
  overflowY: _propTypes2.default.string
};

var propAliases = exports.propAliases = {
  overflow: ['overflowX', 'overflowY']
};

var propValidators = exports.propValidators = {};

var _overflowY = {
  className: 'ovflw-y',
  cssName: 'overflow-y',
  jsName: 'overflowY',
  safeValue: true
};
var _overflowX = {
  className: 'ovflw-x',
  cssName: 'overflow-x',
  jsName: 'overflowX',
  safeValue: true
};

var propEnhancers = exports.propEnhancers = {
  overflowX: function overflowX(value) {
    return (0, _getCss2.default)(_overflowX, value);
  },
  overflowY: function overflowY(value) {
    return (0, _getCss2.default)(_overflowY, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/enhancers/overflow.js
// module id = 341
// module chunks = 0